// import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Constant } from "../../../constants/constant";
import { useAppSelector } from "../../../store/hook";

const activeLink = {
  color: "#4a8ae9",
};

type iconsMap = {
  [key: string]: any;
};
const icons: iconsMap = {
  MNU_01: <i className="pi pi-desktop"></i>,
  MNU_02: <i className="pi pi-microsoft"></i>,
  MNU_03: <i className="pi pi-server"></i>,
};

function NavGroup({ items, showIcon, menuActive }: any) {
  const [openMenu, setOpen] = useState<any>();
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;
  const { t } = useTranslation();
  const sideBarShow = useAppSelector((state: any) => state.layout.sideBarShow);
  const sideBarShowSmall = useAppSelector((state: any) => state.layout.sideBarShowSmall);

  const lang = useAppSelector((state:any) => state.language.lang)

  const translateMenuNm = useCallback(    
    (item: any) => {
      if (Constant.SOUTH_KOREA === lang) {
        return item.menuNm;
      } else if (Constant.ENGLISH === lang) {
        return item.menuNmEn;
      } else {
        return item.menuNmVi;
      }
    },
    [lang]
  );

  useEffect(() => {
    if (menuActive) {
      setOpen(menuActive);
    }
  }, [menuActive]);

  const navGroup = (item: any, showIcon: boolean) => {
    return (
      <li
        key={item.menuId}
        className={`nav-item treeview ${url.includes(item.url) && item.url != "" ? "active" : ""} ${item.menuId === openMenu ? "expand " : "colspan"}`}
        style={!sideBarShow && !sideBarShowSmall ? { backgroundColor: "#fff", minWidth: `${sideBarShow ? "" : !showIcon ? "max-content" : ""}` } : {}}>
        {item.children?.length > 0 ? (
          <a
            id={item.menuId}
            data-bs-toggle="collapse"
            role="button"
            aria-expanded={item.menuId === openMenu}
            onClick={() => {
              if (openMenu == item.menuId) {
                setOpen("");
              } else {
                setOpen(item.menuId);
              }
            }}>
            {showIcon && icons[item.menuId]}
            <span data-key="t-apps">{sideBarShow || sideBarShowSmall ? translateMenuNm(item) : !showIcon ? translateMenuNm(item) : ""}</span>
            <span className="pull-right-container">{openMenu !== item.menuId ? <i className="pi pi-chevron-right"></i> : <i className="pi pi-chevron-down"></i>}</span>
          </a>
        ) : (
          <a id={item.menuId} onClick={() => handleClickLink(item.url)} role="button" aria-expanded="false">
            {showIcon && icons[item.menuId]}
            <span data-key="t-apps">{translateMenuNm(item)}</span>
          </a>
        )}

        {item.children?.length > 0 ? (
          <div className={`collapse menu-dropdown ${item.menuId === openMenu ? "show" : ""} lvl${item.lev}`} id={"MENU_" + item.menuId}>
            <ul className="sidebar-menu" data-widget="tree">
              <NavGroup items={item.children} showIcon={false} />
            </ul>
          </div>
        ) : null}
      </li>
    );
  };

  const handleClickLink = (url: string) => {
    navigate(url);
  };

  const eventListener = useCallback((e: any) => {
    var container = $("div .collapse");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      setOpen("");
    }
  }, []);

  useEffect(() => {
    if (!sideBarShow) {
      document.addEventListener("mouseup", eventListener);
    } else {
      document.removeEventListener("mouseup", eventListener);
    }
  }, [sideBarShow]);

  return <>{items?.map((item: any) => navGroup(item, showIcon))}</>;
}

export default NavGroup;
